import { MigrateDialogTxOverview } from '../types'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'
import { SavingsAccountRepository } from '@/features/savings/logic/savings-converters/types'

export interface CreateTxOverviewParams {
  formValues: TransferFromUserFormNormalizedData
  savingsAccounts: SavingsAccountRepository

  tokenRepository: TokenRepository
  outputToken: Token
}
export function createTxOverview({
  formValues,
  savingsAccounts,
  tokenRepository,
  outputToken,
}: CreateTxOverviewParams): MigrateDialogTxOverview {
  const value = formValues.value
  if (value.eq(0)) {
    return { status: 'no-overview' }
  }

  // sdai -> susds
  const sdai = tokenRepository.findBySymbol(TokenSymbol('sDAI'))
  if (formValues.token.symbol === sdai?.symbol) {
    const sdaiConverter = savingsAccounts.findOneBySavingsTokenSymbol(TokenSymbol('sDAI')).converter
    const susdsConverter = savingsAccounts.findOneBySavingsTokenSymbol(TokenSymbol('sUSDS')).converter

    const apyChange = { current: sdaiConverter.apy, updated: susdsConverter.apy }
    const daiAmount = sdaiConverter.convertToAssets({ shares: value })
    const outcome = {
      token: outputToken,
      value: susdsConverter.convertToShares({ assets: daiAmount }),
      usdValue: daiAmount,
    }

    return { status: 'success', apyChange, outcome }
  }

  // dai <-> usds
  const outcome = {
    token: outputToken,
    value,
    usdValue: value,
  }

  return { status: 'success', outcome }
}
